export const NO_MOCK_CONNECTORS = [
  'choice',
  'do-while-connector',
  'retry-connector',
  'block-execution-connector',
  'parallel-execution-connector',
  'log-connector',
  'throw-error-connector',
  'trigger'
];

export const JSON_GENERATOR_CONNECTOR = 'json-generator-connector';

const DIGIFORM_ALLOW_ADVANCED_CONNECTORS = [
  'rest-connector',
  'soap-connector',
  'soap-connector-v2',
  'soap-connector-v3',
  'webdav-connector-v2',
  'slack-connector',
  'ldap-connector',
  'jwt-connector',
  'generic-jwt-connector',
  'generic-jwt-connector-v2',
  'azure-key-vault-connector',
  'digital-signature-connector',
  's3-storage-connector',
  'google-storage-connector',
  'google-drive-connector',
  'dropbox-connector',
  'onedrive-connector',
  'azure-blob-storage-connector',
  'azure-storage-datalake-connector',
  'stream-db-connector',
  'stream-db-connector-v3',
  'mongodb-connector',
  'cassandra-connector',
  'postgresql-connector',
  'rabbitmq-connector',
  'sqs-connector',
  'kafka-connector',
  'jms-connector',
  'symmetric-cryptography-connector',
  'pbe-cryptography-connector',
  'rsa-cryptography-connector',
  'aes-cryptography-connector',
  'pgp-connector'
];

export const DIGIFORM_ALLOWLIST_COMPONENTS = [
  'log-connector',
  'choice',
  'json-generator-connector',
  'session-management',
  'transformer',
  'throw-error-connector',
  'block-execution-connector',
  'rest-connector-v2',
  'object-store-connector',
  'event-publisher-connector',
  'for-each-connector',
  'json-transformer-connector',
  'db-connector-v2',
  'assert-connector-v2',
  'template-transformer',
  'jolt-connector-v2',
  'soap-connector-v2',
  'soap-connector-v3',
  'json-string-to-json-transformer',
  'json-to-json-string-transformer',
  'json-path-transformer',
  'csv-to-json-transformer',
  'xml-to-json-transformer',
  'json-to-xml-transformer',
  'xml-transformer',
  'json-to-csv-json-transformer',
  'json-to-csv-connector-v2',
  'json-path-connector-v2',
  'assert',
  'delayer',
  'file-reader-connector',
  'file-writer-connector',
  'stream-file-reader-connector',
  'stream-file-reader-pattern-connector',
  'csv-to-json-connector-v2',
  'csv-to-excel-connector',
  'zip-file-connector',
  'zip-file-connector-v2',
  'gzip-connector',
  'gzip-connector-v2',
  'base64-connector',
  'xml-validator-connector',
  'stream-excel-connector',
  'stream-json-file-reader-connector',
  'stream-xml-file-reader-connector',
  'append-files-connector',
  'sap-connector',
  'llm-connector',
  'vector-db-connector',
  ...DIGIFORM_ALLOW_ADVANCED_CONNECTORS
];

export const CAPSULE_PROHIBITED_CONNECTORS = {
  names: [
    'relation-connector',
    'object-store-connector',
    'digibee-storage-connector'
  ]
};

export function getCanShowDigiform(
  connectorName: string | undefined,
  isShowDigiformEnabled: boolean
): boolean {
  return (
    DIGIFORM_ALLOWLIST_COMPONENTS.includes(connectorName || '') ||
    isShowDigiformEnabled
  );
}
